export default __webpack_public_path__ + "static/media/Video_new.c20d00e3.svg";